import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const MenuSubListItem = ({ onClick, id, name }) => (
  <div className="list-item-container" onClick={onClick}>
    <Icon name={`sportIcon-${id}`} alt={name} type="sports" />
    <span>{name}</span>
    <Icon icon="icon-arrow" className="icon-arrow" />
  </div>
);

MenuSubListItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default MenuSubListItem;
